export default "__VITE_ASSET__DJHwyXuH__"